import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const fileUrl = (p) => (!p ? "" : p.startsWith("http") ? p : `${API}/files/${p}`);

export function formatApiError(e, fallback = "Une erreur est survenue. Réessayez.") {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ");
  return fallback;
}
